import { Component, Input, OnChanges } from '@angular/core';
import { ECharts, EChartsOption } from 'echarts';
import { VoltageSpeedDashboardSample } from '../../voltage-with-speed.models';
import { buildTimelineOptions, getTimelinePoints } from './timeline.utils';

@Component({
  selector: 'app-voltage-speed-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.css']
})
export class VoltageSpeedTimelineComponent implements OnChanges {
  @Input() samples: VoltageSpeedDashboardSample[] = [];

  options: EChartsOption = {};
  hasData = false;
  mode: 'both' | 'speed' | 'voltage' = 'both';
  chart: ECharts | null = null;

  ngOnChanges(): void {
    const points = getTimelinePoints(this.samples);
    this.hasData = points.some(point => point.speed != null || point.voltage != null);
    this.mode = 'both';
    this.options = buildTimelineOptions(points);
  }

  setMode(mode: 'both' | 'speed' | 'voltage'): void {
    this.mode = mode;
    this.chart?.dispatchAction({ type: mode === 'voltage' ? 'legendUnSelect' : 'legendSelect', name: 'سرعت' });
    this.chart?.dispatchAction({ type: mode === 'speed' ? 'legendUnSelect' : 'legendSelect', name: 'ولتاژ' });
  }

  zoom(factor: number): void {
    if (!this.chart) return;
    const [range] = this.chart.getOption().dataZoom as { start: number; end: number }[];
    const center = (range.start + range.end) / 2;
    const span = Math.min(100, Math.max(1, (range.end - range.start) * factor));
    const start = Math.max(0, Math.min(100 - span, center - span / 2));
    this.chart.dispatchAction({ type: 'dataZoom', start, end: start + span });
  }

  resetZoom(): void {
    this.chart?.dispatchAction({ type: 'dataZoom', start: 0, end: 100 });
  }

  updateTimeAxis(): void {
    if (!this.chart) return;
    const [range] = this.chart.getOption().dataZoom as { start: number; end: number }[];
    const hours = (range.end - range.start) * 24 / 100;
    const interval = hours > 12 ? 10800 : hours > 5 ? 3600 : hours > 2 ? 1800 : hours > 0.8 ? 900 : 300;
    this.chart.setOption({ xAxis: { interval } });
  }
}
